<!-- TM-1000001915 (B1): render the left nav rail so the 7 NavItems display and are
     clickable. Standard Alpha pattern (EE-ExportType / EA-Project reference): the reusable
     <object-component-navigation-side> two-way-binds activeNavigationItem and emits
     onNavigationItemChange; the content @if blocks below dispatch on the active action.
     activeNavigationItem is defaulted to the first item by the base view's initComponent(). -->
@if (initialized && activeNavigationItem) {
    <div class="cn-commission-rule-full mt-3 grid">

        <!-- ===================== NAVIGATION RAIL ===================== -->
        <div class="col-12">
            <object-component-navigation-side
                    [name]="dto?.['name'] || 'Provisionsregel'"
                    [navigationItems]="navigationItems"
                    [(activeNavigationItem)]="activeNavigationItem"
                    (activeNavigationItemChange)="onNavigationItemChange($event)"
            ></object-component-navigation-side>
        </div>

        <!-- ===================== SECTION CONTENT ===================== -->
        <div class="col-12">

        <!-- ===================== ALLGEMEIN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionRule') {
            @if (ruleWidget) {
                <mvs-widget [widgetData]="ruleWidget"></mvs-widget>
            }
        }

        <!-- ===================== STAFFELN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionRuleTier') {
            @if (tierWidget) {
                <mvs-widget [widgetData]="tierWidget"></mvs-widget>
            }
        }

        <!-- ===================== BEDINGUNGEN ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionCondition') {
            @if (conditionWidget) {
                <mvs-widget [widgetData]="conditionWidget"></mvs-widget>
            }
        }

        <!-- ===================== CAP ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionCap') {
            @if (capWidget) {
                <mvs-widget [widgetData]="capWidget"></mvs-widget>
            }
        }

        <!-- ===================== LOGICHOOK ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionLogicHook') {
            @if (logicHookWidget) {
                <mvs-widget [widgetData]="logicHookWidget"></mvs-widget>
            }
        }

        <!-- ===================== HAFTUNG / KAUTION ===================== -->
        @if (activeNavigationItem.action === 'cn.CommissionLiabilityTemplate') {
            <div class="grid">
                <div class="col-12 mb-3">
                    <div class="text-lg font-medium mb-2">Haftungsvorlagen</div>
                    @if (liabilityTemplateWidget) {
                        <mvs-widget [widgetData]="liabilityTemplateWidget"></mvs-widget>
                    }
                </div>
                <div class="col-12">
                    <div class="text-lg font-medium mb-2">Stornoreserve-Vorlagen (Kaution)</div>
                    @if (cancellationBufferWidget) {
                        <mvs-widget [widgetData]="cancellationBufferWidget"></mvs-widget>
                    }
                </div>
            </div>
        }

        <!-- ===================== VORSCHAU ===================== -->
        @if (activeNavigationItem.action === 'preview') {
            <mvs-cn-rule-preview
                    [commissionRuleId]="objectIdentifier.objectId"
                    [commissionModelId]="commissionModelId">
            </mvs-cn-rule-preview>
        }

        </div>
    </div>
}
